import { combineReducers } from "@reduxjs/toolkit";
import { History } from "history";

import { connectRouter } from "connected-react-router";
import globalSlice from "./globalSlice";

const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        global: globalSlice,
    });

export default createRootReducer;
